module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n        Printer\n    ")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "IP Printer"
    },
    model: {
      value: (_vm.printerIP),
      callback: function($$v) {
        _vm.printerIP = $$v
      },
      expression: "printerIP"
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "Printer name"
    },
    on: {
      "on-change": _vm.saveData
    },
    model: {
      value: (_vm.printer.printername),
      callback: function($$v) {
        _vm.$set(_vm.printer, "printername", $$v)
      },
      expression: "printer.printername"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n        Server\n    ")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "Server",
      "readonly": ""
    },
    model: {
      value: (_vm.serverIP),
      callback: function($$v) {
        _vm.serverIP = $$v
      },
      expression: "serverIP"
    }
  })], 1), _vm._v(" "), _c('br')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54a68670","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 1809
// module chunks = 1